import Vue from 'vue';
import store from './../../store';
import productTransformer from './../../transformers/product';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const products = productTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedProducts', { products, pagination });
  resolve(products);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('product_bundles', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productBundle/items.js